import { Component, Input, Inject, OnInit } from '@angular/core';
import { ActivityTypeDataService } from "../core/activitytypes.dataservice";
import { WorkSchedulesDataService } from "../core/workschedules.dataservice";
//import { ITime } from 'angular-material-time-control/src/time-control/w-clock/w-clock.component';

@Component({
    selector: "crew-workschedule-steps",
    template: require('./work-schedule-steps.component.html')
})
export class WorkScheduleSteps implements OnInit {
    private activityTypes: Nema.Crew.Model.ActivityType[];

    constructor(
        @Inject(WorkSchedulesDataService.Id) private workScheduleDataService: WorkSchedulesDataService,
        @Inject(ActivityTypeDataService.Id) private activityTypeDataService: ActivityTypeDataService) {

        // default values
        this.isReadonly = false;
    }

    ngOnInit() {
        this.activityTypeDataService
            .getAll()
            .then(res => this.activityTypes = res);
    }

    @Input()
    workSchedule: Nema.Crew.Model.WorkSchedule;

    @Input()
    isReadonly: boolean;

    public addStep(): void {
        var newStep = this.workScheduleDataService.newWorkScheduleStep(this.activityTypes[0].Id);
        
        this.workSchedule.Steps.push(<any>newStep);
    }

    public removeStep(step: Nema.Crew.Model.WorkScheduleStep): void {
        var index = this.workSchedule.Steps.indexOf(step, 0);
        if (index > -1) {
            var stepToDelete = this.workSchedule.Steps[index];
            this.workScheduleDataService.removeMapping(stepToDelete, () => this.workSchedule.Steps.splice(index, 1));
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/activities/work-schedule-steps.component.ts